import { ConnectionCubeSearchRequirements } from '@article/components/connections/connection-creation/search/connection-cube-search-requirements';

export class GroupedCubesSearchRequirements {

  public searchRequirements: ConnectionCubeSearchRequirements[];

  public constructor(searchRequirements: ConnectionCubeSearchRequirements[]) {
    this.searchRequirements = searchRequirements;
  }
}
